export const selectStyles = {
  indicatorSeparator: () => ({
    display: "none",
  }),
  control: (provided, state) => ({
    width: "250px",
    display: "flex",
    flexDirection: "row-reverse",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    fontWeight: "500 !important",
    fontSize: "1.5em",
    fontFamily: "Gordita",
    color: "black",
    alignItems: "top",
    padding: "0px 8px",
  }),
  singleValue: (provided, state) => ({
    color: "black",
    top: 0,
  }),
  input: (provided, state) => ({
    color: "black",
    top: 0,
    fontWeight: "500 !important",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "black",
    padding: 0,
    svg: {
      height: "30px",
      width: "30px",
    },
  }),
};
